import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedVideos from './components/FeaturedVideos';
import CategorySection from './components/CategorySection';
import LatestVideos from './components/LatestVideos';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedVideos />
        <CategorySection />
        <LatestVideos />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '黑料视频',
            url: 'https://heiliaoshipin.com/',
            description: '黑料视频官网提供海量黑料视频在线观看，聚合黑料视频网、黑料视频网站等高清免费入口，即时访问最新吃瓜爆料视频，无需下载直接在线看。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://heiliaoshipin.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '黑料视频',
            url: 'https://heiliaoshipin.com/',
            description: '国内领先的娱乐资讯视频聚合平台',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-8888',
              contactType: 'customer service',
            },
          }),
        }}
      />
    </>
  );
}